module.exports = "/assets/data/39d35cf3477beb404d3837d466326394-RG6.data.json";